export const OAUTH_RESULT_STATUS = Object.freeze({
  SUCCESS: 'success',
  ERROR: 'error',
});

export const getOAuthResultStatus = (search) => {
  const oauthResults = new URLSearchParams(search || '').getAll('oauth');

  return oauthResults.length === 1 && oauthResults[0] === OAUTH_RESULT_STATUS.SUCCESS
    ? OAUTH_RESULT_STATUS.SUCCESS
    : OAUTH_RESULT_STATUS.ERROR;
};
